import { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useNotification } from '../../contexts/NotificationContext';
import { authFetch } from '../../utils/authFetch';
import { uploadImagem } from '../../firebase/uploadImagem';

const NovoTerapeuta = () => {
    const navigate = useNavigate();
    const { showNotification } = useNotification();
    const fileInputRef = useRef(null);

    const formatarMoeda = (valor) => {
        // Remove tudo que não for dígito
        const numero = valor.replace(/\D/g, '');

        // Converte para float com 2 casas decimais
        const float = (parseFloat(numero) / 100).toFixed(2);

        // Formata com ponto de milhar e vírgula decimal
        return float
            .replace('.', ',')                          // vírgula decimal
            .replace(/\B(?=(\d{3})+(?!\d))/g, '.');     // ponto milhar
    };


    const [formData, setFormData] = useState({
        name: '',
        nickname: '',
        therapistLevel: '',
        birthdate: '',
        introduction: '',
        vacationDate: '',
        hiringDate: '',
        principles: '',
        color: '#000000',
        userId: null,
        sessionFee: '',
        extraFee: '',
        disabled: false,
        // photo: null,
    });

    const niveisTerapeuta = {
        0: 'Gestora',
        1: 'Júnior',
        2: 'Estagiária',
        3: 'Sênior',
    };

    const [preview, setPreview] = useState(null);

    const handleChange = (e) => {
        const { name, value, files } = e.target;

        if (name === 'image' && files.length > 0) {
            const file = files[0];

            // Atualiza o estado com o arquivo
            setFormData((prev) => ({
                ...prev,
                image: file,
            }));

            // Atualiza o preview
            const reader = new FileReader();
            reader.onloadend = () => {
                setPreview(reader.result);
            };
            reader.readAsDataURL(file);
        } else {
            // Para os outros campos
            setFormData((prev) => ({
                ...prev,
                [name]: value,
            }));
        }
    };

    const parseMoedaParaNumero = (valor) => {
        if (!valor) return 0;
        return parseFloat(valor.replace(/\./g, '').replace(',', '.'));
    };
    
    const handleSubmit = async (e) => {
        e.preventDefault();

        const imageFile = formData.image;
        let imageUrl = null;

        const level =
            formData.therapistLevel === undefined ||
                formData.therapistLevel === null ||
                formData.therapistLevel === ""
                ? 0
                : formData.therapistLevel;

        const payload = {
            ...formData,
            therapistLevel: level,
            sessionFee: parseMoedaParaNumero(formData.sessionFee),
            extraFee: parseMoedaParaNumero(formData.extraFee),
        };

        try {
            const response = await authFetch('therapist', {
                method: 'POST',
                body: JSON.stringify(payload),
            });

            if (!response.ok) throw new Error();

            const savedData = await response.json();
            const newId = savedData.id;

            // Upload da imagem no Firebase, se houver
            if (imageFile && newId) {
                imageUrl = await uploadImagem(imageFile, 'therapist', newId);
            }

            showNotification('success', 'Terapeuta criado com sucesso!');
            navigate('/Terapeutas');
        } catch (error) {
            console.error(error);
            showNotification('danger', 'Erro ao criar terapeuta');
        }
    };


    return (
        <div className="card">
            <div className="card-body p-3">
                <div className="row">
                    <aside className="column">
                        <div className="side-nav">
                            <h4 className="font-weight-bolder mb-0">Novo Terapeuta</h4>
                            <br />
                        </div>
                    </aside>
                    <div className="column-responsive column-80">
                        <div className="terapeutas form content">
                            <form onSubmit={handleSubmit}>
                                <fieldset className="col-md-6">
                                    <div className="row col-md-12">
                                        <div className="col-md-2">
                                            <div className="personal-image">
                                                <input
                                                    type="file"
                                                    name='image'
                                                    id='arquivo'
                                                    onChange={handleChange}
                                                    ref={fileInputRef}
                                                    style={{ display: 'none' }}
                                                />
                                                <figure className="personal-figure">
                                                    <img
                                                        src={preview || require('../../assets/img/perfilvazio.png')}
                                                        alt="imagem-perfil"
                                                        className="personal-avatar"
                                                        onClick={() => fileInputRef.current.click()}
                                                        style={{ cursor: 'pointer', width: '100%' }}
                                                    />
                                                </figure>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="form-check form-switch">
                                        <input
                                            type="checkbox"
                                            className="form-check-input"
                                            name="disabled"
                                            checked={formData.disabled}
                                            onChange={handleChange}
                                        />
                                        <label className="form-check-label">Desativado</label>
                                    </div>

                                    <div className="form-group">
                                        <label>Nome</label>
                                        <input
                                            type="text"
                                            name="name"
                                            className="form-control form-control-sm"
                                            value={formData.name}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label>Apelido</label>
                                        <input
                                            type="text"
                                            name="nickname"
                                            className="form-control form-control-sm"
                                            value={formData.nickname}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label>Data de Nascimento</label>
                                        <input
                                            type="date"
                                            name="birthdate"
                                            className="form-control form-control-sm"
                                            value={formData.birthdate}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label>Nível</label>
                                        <select
                                            name="therapistLevel"
                                            className="form-control form-control-sm"
                                            value={
                                                formData.therapistLevel === undefined ||
                                                    formData.therapistLevel === null ||
                                                    formData.therapistLevel === ""
                                                    ? 0
                                                    : formData.therapistLevel
                                            }
                                            onChange={handleChange}
                                        >
                                            {Object.entries(niveisTerapeuta).map(([valor, label]) => (
                                                <option key={valor} value={valor}>
                                                    {label}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    <div className="form-group">
                                        <label>Data de Início Autin</label>
                                        <input
                                            type="date"
                                            name="hiringDate"
                                            className="form-control form-control-sm"
                                            value={formData.hiringDate}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label>Valor Extra</label>
                                        <input
                                            type="text"
                                            name="extraFee"
                                            className="form-control form-control-sm"
                                            value={formData.extraFee || ''}
                                            onChange={(e) =>
                                                setFormData((prev) => ({
                                                    ...prev,
                                                    extraFee: formatarMoeda(e.target.value),
                                                }))
                                            }
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label>Cor</label>
                                        <input
                                            type="color"
                                            name="color"
                                            className="form-control form-control-sm"
                                            value={formData.color}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label>Data das Próximas Férias</label>
                                        <input
                                            type="date"
                                            name="vacationDate"
                                            className="form-control form-control-sm"
                                            value={formData.vacationDate}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label>Valores</label>
                                        <input
                                            type="text"
                                            name="principles"
                                            className="form-control form-control-sm"
                                            value={formData.principles}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label>Apresentação</label>
                                        <textarea
                                            name="introduction"
                                            className="form-control form-control-sm"
                                            value={formData.introduction}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="card-footer" style={{ paddingLeft: 0 }}>
                                        <button
                                            type="button"
                                            className="btn btn-info btn-sm"
                                            onClick={() => navigate('/Terapeutas')}
                                        >
                                            Cancelar
                                        </button>
                                        <button type="submit" className="btn btn-primary btn-sm">
                                            Salvar
                                        </button>
                                    </div>
                                </fieldset>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NovoTerapeuta;
